// App utils
(function() {
	const expandContent = e => {
		e.preventDefault();

		const element = e.target;
		let target = null;

		if (typeof element === 'object') {
			target = document.getElementById(element.getAttribute('data-target').substring(1));

			if (typeof target === 'object') {
				target.classList.add('show');
				element.classList.add('d-none');
			}
		}
	};

	const collapse = () => {
		const links = document.querySelectorAll('[data-js="collapse"]');

		links.forEach(link => {
			link.addEventListener('click', expandContent);
		});
	};

	document.addEventListener('DOMContentLoaded', collapse);
})();
